export const TIME_BILLING_PATH = '/time-billing';

// Navigation visibility mirrors the existing global time-entry action.
// The authenticated route and API remain the authorization boundaries.
export const canNavigateTimeBilling = (accessLevel) => !['', 'no access', 'storms'].includes(
    String(accessLevel || '').trim().toLowerCase(),
);
